import script from "./AliyunDDns.vue?vue&type=script&setup=true&lang=js"
export * from "./AliyunDDns.vue?vue&type=script&setup=true&lang=js"

import "./AliyunDDns.vue?vue&type=style&index=0&id=48b3bc58&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48b3bc58"]])

export default __exports__